"use client"

import { User, Shield, Clock } from "lucide-react"
import Image from "next/image"
import { shorterDate } from '@/utils/index'

type SellerInfoProps = {
  seller: {
    avatar: string
    fullName: string
    createdAt: string
  }
}

export function SellerInformation({ seller, translations }: SellerInfoProps & { translations: Record<string, any> }) {
  return (
    <div className="space-y-4">
      <div className="mb-4 flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-200">
          {seller.avatar ? (
            <Image
              className="h-12 w-12 rounded-full"
              src={seller.avatar}
              alt={seller.fullName}
              width={24}
              height={24}
            />
          ) : (
            <User size={24} className="text-gray-500" />
          )}
        </div>
        <div>
          <h4 className="font-medium">{seller.fullName}</h4>
          <p className="text-sm text-gray-500">{`Member since ${shorterDate( new Date().toISOString())}`}</p>
        </div>
      </div>
      <div className="space-y-3 text-sm">
        <div className="flex items-center gap-2 text-gray-600">
          <Shield size={16} className="text-green-500" />
          <span>{translations.verifiedSeller}</span>
        </div>
        <div className="flex items-center gap-2 text-gray-600">
          <Clock size={16} />
          <span>{translations.usuallyResponds}</span>
        </div>
      </div>
    </div>
  )
}
